import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainNonPaymentBlockingCountQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainNonPaymentBlockingCountQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', notBlocked?: number | null, outgoingBlocked?: number | null, incomingAndOutgoingBlocked?: number | null } | null> } | null };


export const DomainNonPaymentBlockingCountDocument = gql`
    query DomainNonPaymentBlockingCount($domainId: Int!) {
  domains(id: $domainId) {
    items {
      notBlocked
      outgoingBlocked
      incomingAndOutgoingBlocked
    }
  }
}
    `;

/**
 * __useDomainNonPaymentBlockingCountQuery__
 *
 * To run a query within a React component, call `useDomainNonPaymentBlockingCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainNonPaymentBlockingCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainNonPaymentBlockingCountQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainNonPaymentBlockingCountQuery(baseOptions: Apollo.QueryHookOptions<DomainNonPaymentBlockingCountQuery, DomainNonPaymentBlockingCountQueryVariables> & ({ variables: DomainNonPaymentBlockingCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainNonPaymentBlockingCountQuery, DomainNonPaymentBlockingCountQueryVariables>(DomainNonPaymentBlockingCountDocument, options);
      }
export function useDomainNonPaymentBlockingCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainNonPaymentBlockingCountQuery, DomainNonPaymentBlockingCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainNonPaymentBlockingCountQuery, DomainNonPaymentBlockingCountQueryVariables>(DomainNonPaymentBlockingCountDocument, options);
        }
export function useDomainNonPaymentBlockingCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNonPaymentBlockingCountQuery, DomainNonPaymentBlockingCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainNonPaymentBlockingCountQuery, DomainNonPaymentBlockingCountQueryVariables>(DomainNonPaymentBlockingCountDocument, options);
        }
export type DomainNonPaymentBlockingCountQueryHookResult = ReturnType<typeof useDomainNonPaymentBlockingCountQuery>;
export type DomainNonPaymentBlockingCountLazyQueryHookResult = ReturnType<typeof useDomainNonPaymentBlockingCountLazyQuery>;
export type DomainNonPaymentBlockingCountSuspenseQueryHookResult = ReturnType<typeof useDomainNonPaymentBlockingCountSuspenseQuery>;
export type DomainNonPaymentBlockingCountQueryResult = Apollo.QueryResult<DomainNonPaymentBlockingCountQuery, DomainNonPaymentBlockingCountQueryVariables>;